import { Button } from '@toggle/design-system';
import styled, { css } from 'styled-components';

const noBorderButton = css`
  border: none;
  box-shadow: none;
  border-radius: 7px;

  &:hover,
  &:focus,
  &:focus-visible,
  &:disabled {
    border: none;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
`;

export const ScheduleButton = styled(Button)`
  ${noBorderButton}
`;

export const SubmitButton = styled(Button)`
  ${noBorderButton}
`;
